import React, { useState } from 'react'
import YnsIcon from '../icons/YnsIcon'

const QuestionWithChoices = ({ question, choices, onRatingChange }) => {
  const [hoverRating, setHoverRating] = useState(null)
  const [feedbackRating, setFeedbackRating] = useState(null)

  const handleRatingClick = (rating) => {
    const newRating = feedbackRating === rating ? null : rating
    setFeedbackRating(newRating)
    onRatingChange(newRating)
  }

  const handleRatingMouseOver = (rating) => setHoverRating(rating)
  const handleRatingMouseOut = () => setHoverRating(null)

  const gradientColors = ['#FFECB3', '#FFD54F', '#FFCA28', '#FFC000', '#FFB72F']

  return (
    <div className="mb-10">
      <p className="!mb-5 !font-bold">{question}</p>
      <div className="grid max-w-[90%] grid-cols-5 items-center md:max-w-[400px]">
        {choices.map((choice, index) => {
          const ratingValue = index + 1
          const isSolid =
            hoverRating !== null
              ? ratingValue <= hoverRating
              : feedbackRating !== null && ratingValue <= feedbackRating

          const starColor = isSolid
            ? gradientColors[index] || '#E0E0E0'
            : '#E0E0E0'

          const showTooltip =
            hoverRating === ratingValue || feedbackRating === ratingValue

          return (
            <div
              key={index}
              className="rating ga-trackable relative flex flex-col items-center justify-center"
              onClick={() => handleRatingClick(ratingValue)}
              onMouseOver={() => handleRatingMouseOver(ratingValue)}
              onMouseOut={handleRatingMouseOut}
            >
              <YnsIcon
                name={isSolid ? 'star-solid' : 'star'}
                size={32}
                style={{ color: starColor }}
              />
              {showTooltip && (
                <span
                  className="absolute top-full mt-2 whitespace-nowrap rounded-md border bg-white px-2 py-1 text-center text-sm shadow-md transition-opacity duration-200 ease-in-out"
                  style={{
                    minWidth: '100px',
                    opacity: 1,
                    pointerEvents: 'auto',
                  }}
                >
                  {choice}
                </span>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default QuestionWithChoices
